import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src477529347/src/autopatcher-docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "patching-logs---ssm-agent-and-hooks-outputs"
    }}>{`Patching logs - SSM agent and hooks outputs`}</h1>
    <p>{`During patching AutoPatcher produces several outputs from:`}</p>
    <ul>
      <li parentName="ul">{`SSM Agent at patched machines`}</li>
      <li parentName="ul">{`hooks`}</li>
      <li parentName="ul">{`host hooks`}</li>
    </ul>
    <p>{`Outputs are stored to S3 buckets.`}</p>
    <h2 {...{
      "id": "output-storage-region"
    }}>{`Output storage region`}</h2>
    <p>{`Logs storage location can be selected for AWS instances during customer onboarding.`}</p>
    <p>{`Common buckets are located in the main AutoPatcher region - currently eu-central-1 (Frankfurt).
Dedicated bucket location can be specified as any valid AWS region.`}</p>
    <h2 {...{
      "id": "hybrid-machine-outputs"
    }}>{`Hybrid machine outputs`}</h2>
    <p>{`SSM agent logs from hybrid instances (Azure, GCP, other non-AWS providers) and their host hooks outputs are stored only in common logs buckets.`}</p>
    <h2 {...{
      "id": "ec2-service-roles-and-policy-templates"
    }}>{`EC2 service roles and policy templates`}</h2>
    <p>{`Each customer can have different setup for storing the patching logs.
AutoPatcher provides an auto-generated policy and service role CloudFormation templates for AWS EC2 machines.`}</p>
    <p>{`All generated permissions have minimum access rules needed for storing outputs to proper S3 buckets.`}</p>
    <p>{`The full process of onboarding the customer AWS account is described `}<a parentName="p" {...{
        "href": "/setting-up-ssm#setting-up-ssm-in-iam-mode"
      }}>{`here`}</a></p>
    <p>{`To download CloudFormation templates navigate to `}<a parentName="p" {...{
        "href": "https://autopatcher.nordcloudapp.com/machines/new"
      }}>{`NEW MACHINE`}</a>{` page:`}</p>
    <ol>
      <li parentName="ol">{`Click on `}<b>{`GET IAM POLICY FOR EC2`}</b>{` or `}<b>{`GET IAM SERVICE ROLE`}</b>{` button (a popup window with template preview will appear)`}</li>
      <li parentName="ol">{`Click `}<b>{`DOWNLOAD TEMPLATE`}</b>{` button`}</li>
    </ol>
    <p><img alt="cloudformation-templates" src={require("../assets/patching-logs/cloudformation-templates.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      